<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.073" height="17.221" viewBox="0 0 17.073 17.221">
    <g id="copy" transform="translate(0.625 0.625)">
      <rect id="Rectangle_1734" data-name="Rectangle 1734" width="10.83" height="10.83" rx="1.5" transform="translate(4.993 5.141)" fill="none" stroke="#2c3e50" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
      <path id="Path_415" data-name="Path 415" d="M4.549,13.046H3.7a1.7,1.7,0,0,1-1.7-1.7V3.7A1.7,1.7,0,0,1,3.7,2h7.647a1.7,1.7,0,0,1,1.7,1.7v.85" transform="translate(-2 -2)" fill="none" stroke="#2c3e50" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
    </g>
  </svg>
</template>
